<template>
	<div class="card" :class="'card-' + card.type">
		<div class="bg" v-bg="card_bg"></div>
		<div class="illustration">
			<div v-if="card.type === 'scroll'" class="img" v-bg="'cards/scroll/default.png'"></div>
			<div v-else class="img" v-bg="'cards/' + card.type + '/' + card.slug + '.png'"></div>
		</div>
		<div class="name">{{ card[lang].name }}</div>
		<div class="description">
			<ui-text :text="card[lang].description" :value="card_value" />
		</div>
		
		<div v-if="card_value !== null" class="value">
			<ui-stat :type="card_type" :value="card_value" :size="80" />
		</div>
		<div v-if="card.durability" class="durability">
			<div v-for="i in card_durability" :key="i" class="dot full"></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UiText from '@/components/ui/ui-text'
import UiStat from '@/components/ui/ui-stat'
import { get_card_value, get_card_value_type } from '@/js/board'

export default {
	name: 'card',
	props: {
		card: { default: null }
	},
	computed: {
		...mapGetters([ 'lang' ]),
		card_bg() {
			const types = [ 'armor', 'life', 'gold', 'attack', 'scroll' ]
			if (types.includes(this.card_type)) return 'card-bg-' + this.card_type + '.png'
			return 'card-bg-default.png'
		},
		card_value() {
			if (this.card.value !== null)
				return get_card_value(this.card, this.card_type)
			return null
		},
		card_durability() {
			return get_card_value(this.card, 'durability')
		},
		card_type() {
			return get_card_value_type(this.card)
		},
	},
	components: { UiText, UiStat }
}
</script>

<style lang="stylus" scoped>

.card
	width card_width
	height card_height
	box-shadow -4px 4px 4px 4px alpha(#000, 50%)
	// box-shadow -8px 8px 4px alpha(#000, 50%)
	border-radius 12px
	flex center center column
	text-align center
	color dark
	font-size 2.6rem
	line-height 20px
	&.card-weapon, &.card-shield
		.illustration
			top 56px
	&.card-weapon
		.durability .dot
			background-color #F69E21
	&.card-shield
		.durability .dot
			background-color #646F9E
	&.card-scroll
		.bg
			top -40px
			left -25px
			right -25px
		.illustration
			top -28px
			left calc(50% - 8px)
		.name
			bottom 142px
			height 56px
			padding 0 16px
		.description
			height 130px
	.bg
		absolute -1px
		background center center no-repeat
		background-size 100% 100%
		pointer-events none
	.durability
		position absolute
		left 0
		right 0
		top 28px
		flex center center
		.dot
			width 22px
			height 22px
			border-radius 50%
			border 3px solid #FBF1E0
			// box-shadow inset 0 0 0 3px #FBF1E0
			
	.illustration
		position absolute
		left 50%
		top 48px
		transform translateX(-50%)
		.img
			width round(card_width / 2)
			height @width
			background center center no-repeat
			background-size contain
	.name
		position absolute
		left 0
		right 0
		bottom 110px
		height 40px
		padding 0 8px
		flex center center 
		font-size 3.2rem
		line-height 20px
		// background-color alpha(#000, 10%)
	.description
		position absolute
		left 0px
		bottom 8px
		right 0px
		padding 0 24px
		height 120px
		line-height 20px
		// background-color alpha(#000, 20%)
		flex center center
	.value
		position absolute
		left -28px
		top -28px
		// width 80px
		// height 80px
		// background-color red
		// border-radius 50%
		flex center center
		color #fff
		font-size 6.4rem
		// border 6px solid #fff
		// box-shadow 0 0 8px 2px alpha(#000, 50%)

</style>
